import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { adminLogin } from "@/lib/api";
import { useAdminAuth } from "@/lib/adminAuth";

const AdminLogin = () => {
    const { user, signIn } = useAdminAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    if (user) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");
        try {
            const r = await adminLogin(email, password);
            signIn(r.token, r.user);
            navigate("/admin");
        } catch (err) {
            setError(err.response?.data?.detail || "Login failed");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="min-h-screen bg-[var(--bg)] text-[var(--text)] flex flex-col items-center justify-center px-6"
            data-testid="admin-login-page"
        >
            <Link
                to="/"
                className="absolute top-6 left-6 font-mono text-[10px] uppercase tracking-[0.22em] text-muted hover:text-gold"
            >
                ← naami<span className="text-gold">.</span> hub
            </Link>

            <div className="w-full max-w-md">
                <p className="eyebrow text-center justify-center mb-3">// Admin Console</p>
                <h1 className="font-display text-[40px] text-center mb-2 leading-tight">
                    Sign <span className="text-gold">in.</span>
                </h1>
                <p className="text-muted text-center text-sm mb-10">
                    Master admin &amp; brand owners
                </p>

                <form onSubmit={submit}>
                    <label className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted block mb-2">Email</label>
                    <input
                        className="input mb-5"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="you@brand.com"
                        data-testid="admin-email"
                    />
                    <label className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted block mb-2">Password</label>
                    <input
                        className="input mb-6"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        data-testid="admin-password"
                    />
                    {error && (
                        <p className="text-[#ff5246] text-sm font-mono mb-4" data-testid="admin-login-error">
                            {error}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={submitting}
                        className="btn-primary w-full justify-center"
                        data-testid="admin-login-submit"
                    >
                        {submitting ? "Signing in…" : "Sign in →"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
